export function Footer() {
  return (
    <footer className="footer">2025 - Crypto Cricket - No Copyright!</footer>
  );
}
